// lib
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'dva';
import { Spin } from 'antd';
import NotMatch from '../../components/NotMatch';

// util
import { flattenRoute } from '../../utils';
import { NO_LOADING_MODELS } from '../../constants/config';

// routes
import routes from '../../routes';

@connect(({ switchContainer, loading }) => ({ ...switchContainer, ...loading }))

class Container extends PureComponent {
  constructor(props) {
    super(props);
    this.flatRoutes = [];
  }

  componentWillMount() {
    flattenRoute(routes, '/', this.flatRoutes);
    this.getLazyComponent(this.props.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.getLazyComponent(nextProps.location.pathname);
    }
  }

  getRouteComponent = (path) => {
    const route = this.flatRoutes.find(val => val.path === path);
    return route && route.component;
  };

  getLazyComponent = (pathname) => {
    const lazyComponent = this.getRouteComponent(pathname);
    this.props.dispatch({
      type: 'switchContainer/change',
      payload: lazyComponent ? lazyComponent : <NotMatch text={'抱歉，您访问的页面不存在。'}/>
    }).then(() => {
      window.scrollTo(0, 0);
    });
  };

  // 所有请求是否正在请求
  isLoadingModels = () => {
    const models = this.props.effects || {};
    for (let modelsKey in models) {
      if (!models.hasOwnProperty(modelsKey)) {
        break;
      }
      if (models[modelsKey] && !NO_LOADING_MODELS.find(item => item === modelsKey)) {
        return true;
      }
    }
    return false;
  };

  render() {
    return (
      <Spin spinning={this.isLoadingModels()}>
        {
          Object.keys(this.props.component).length > 0 ? this.props.component : null
        }
      </Spin>
    )
  }
}

export default withRouter(Container);



// WEBPACK FOOTER //
// ./src/components/Layout/Container.js